import React, { FunctionComponent } from 'react';
import { Modal, View, StyleSheet, StatusBar, Pressable } from 'react-native';
import { 
    Box, 
    HStack, 
    Text, 
    Icon, 
    CloseIcon, 
    VStack 
} from '@gluestack-ui/themed';
import { Ionicons } from "@expo/vector-icons";
import { StatusScreen } from '../../screens';

export interface IModalFullProps {
    visible?: boolean;
    title?: string;
    rightButtons?: any;
    closeButton_onPress?: () => void;
    footer?: any;
    children?: React.ReactNode;
}

export const ModalFull: FunctionComponent<IModalFullProps> = (props) => {
    return (
        <Modal 
            visible={props.visible} 
            animationType='slide' 
            transparent={true} 
            onRequestClose={props.closeButton_onPress}
        >
            <StatusBar backgroundColor="$primary400" barStyle="light-content" />
            
            {/* Reemplazo de safeAreaTop de NativeBase */}

            <View style={styles.modalOverlay}>
                <View style={styles.modalContent}>
                    
                    {/* HEADER - Usando Gluestack para el tema de colores */}
                    <HStack 
                        bg="$primary400" 
                        w="$full" 
                        alignItems="center" 
                        justifyContent="space-between"
                        px="$4" 
                        py="$1"
                    >
                        <View style={styles.titleContainer}>
                            <Text color="$white" size="md" fontWeight="$bold" numberOfLines={1}>
                                {props.title ?? ""}
                            </Text>
                        </View>

                        <HStack alignItems="center" space="md">
                            {props.rightButtons}
                            {props.closeButton_onPress && (
                                <Pressable 
                                    onPress={props.closeButton_onPress}
                                    hitSlop={15}
                                    style={styles.closeButton}
                                >
                                    <Icon as={Ionicons} name="close" color="$white" size="md" />
                                </Pressable>
                            )}
                        </HStack>
                    </HStack>

                    {/* BODY - Vista nativa para máximo rendimiento */}
                    <View style={styles.body}>
                        {props.children}
                    </View>

                    {/* FOOTER */}
                    {props.footer && (
                        <View style={styles.footerContainer}>
                            {props.footer}
                        </View>
                    )}
                </View>
            </View>

            {/* El StatusScreen se mantiene para logs internos */}
            <StatusScreen />
        </Modal>
    );
};

const styles = StyleSheet.create({
    modalOverlay: { 
        flex: 1, 
        justifyContent: "center", 
        alignItems: "center", 
        backgroundColor: "rgba(0,0,0,0.5)" // Agregamos un fondo tenue para mejorar la UX
    },
    modalContent: { 
        backgroundColor: "#ccc", 
        width: "100%", 
        height: "100%", 
        borderRadius: 0 
    },
    titleContainer: { 
        flex: 1, 
        marginRight: 10 
    },
    body: { 
        flex: 1, 
        backgroundColor: "#fff" // Cambiado de #eee a #fff para consistencia visual
    },
    footerContainer: { 
        width: "100%",
        borderTopWidth: 1,
        borderTopColor: '#f0f0f0', flexDirection:"row"
    },
    closeButton: {
        padding: 5,
        justifyContent: 'center',
        alignItems: 'center'
    }
});